import { Check } from 'lucide-react';
import type { CarouselStyleDto } from '../../lib/api';
import { Button, Modal } from '../ui';
import { SlideCarousel } from './SlideCarousel';

export interface StylePreviewModalProps {
  /** null = closed. */
  style: CarouselStyleDto | null;
  selected: boolean;
  onSelect: (code: string) => void;
  onClose: () => void;
}

/** Sample deck rendered in one style, with a button to pick that style. */
export function StylePreviewModal({ style, selected, onSelect, onClose }: StylePreviewModalProps) {
  return (
    <Modal open={style !== null} onClose={onClose} title={style?.name}>
      {style && (
        <>
          <p className="text-sm text-tg-hint -mt-2 mb-3 leading-snug">{style.description}</p>
          <SlideCarousel urls={style.preview_urls} className="mb-4" />
          <Button
            onClick={() => {
              onSelect(style.code);
              onClose();
            }}
            disabled={selected}
            variant="primary"
            size="lg"
            fullWidth
            leftIcon={<Check size={18} />}
          >
            {selected ? 'Стиль выбран' : 'Выбрать стиль'}
          </Button>
        </>
      )}
    </Modal>
  );
}
